module.exports = __webpack_public_path__ + "images/bailli-14bb1b7e73e9d5d4391910a11591ec30.jpg";